import { useEffect, useState } from "react";
import PlaySourceContent from "../PlaySourceContent";
import { repeatIsLoop, repeatIsTimes } from "../PlayArea.logic";
import { PlayRepeat, PlaySource } from "type/panel/Panel.type";

type Props = {
  source: PlaySource;
  playMapInd: number;
  areaInd: number;
  onTimesCountElapse: Function;
};

const PlayAreaRepeat = ({
  source,
  playMapInd,
  areaInd,
  onTimesCountElapse,
}: Props) => {
  const [playActive, setPlayActive] = useState<boolean>(false);
  const [repeatCount, setRepeatCount] = useState<number | null>(null);

  useEffect(() => {
    if (repeatCount !== null && (repeatCount > 0 || repeatCount < 0)) {
      setPlayActive(true);
    } else if (repeatCount === 0) {
      onTimesCountElapse();
    }
  }, [repeatCount]);

  useEffect(() => {
    if (repeatCount !== null) {
      if (repeatCount > 0 || repeatCount < 0) {
        if (!playActive) {
          setRepeatCount(repeatCount - 1);
        }
      }
    } else {
      if (typeof source.repeat === "number") {
        setRepeatCount(source.repeat);
      } else {
        setRepeatCount(-1);
      }
    }
  }, [playActive]);

  const elapseHandle = () => {
    setPlayActive(false);
  };

  return (
    <>
      {playActive &&
        repeatCount !== null &&
        (repeatCount > 0 || repeatCount < 0) && (
          <>
            <PlaySourceContent
              contentSource={source}
              playMapInd={playMapInd}
              areaInd={areaInd}
              onElapse={elapseHandle}
            />
          </>
        )}
    </>
  );
};

export default PlayAreaRepeat;
